<template>
  <router-view />
</template>

<script setup lang="ts">
import { onMounted } from "vue"
import { useNotificationStream } from "@/composables/useNotificationStream"

/** Stream inbox: jalankan setelah mount agar Pinia + router siap (hindari getActivePinia error). */
onMounted(() => {
  useNotificationStream()
})
</script>

<style lang="scss">
#app {
  font-family:
    "Inter",
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    Roboto,
    Oxygen,
    Ubuntu,
    Cantarell,
    "Fira Sans",
    "Droid Sans",
    "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body {
  height: 100%;
  background-color: #141414;
  color: #ffffff;
}
</style>
